/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { action } from "@ember/object";
import { service } from "@ember/service";
import Component from "@glimmer/component";
import type Patient from "parog-web/models/patient";
import type { EmberChangeset } from "ember-changeset";
import type ICD10Service from "parog-web/services/icd10";
import type SemeiaSessionService from "parog-web/services/session";

interface Args {
  patient: Patient;
  changeset: EmberChangeset;
}
export default class ICD10Dropdown extends Component<Args> {
  @service declare icd10: ICD10Service;
  @service declare session: SemeiaSessionService;

  get suggestionsForFur(): string[] {
    const suggestions = this.icd10.suggestedIcd10ForFur(
      this.args.patient.followUpReason
    );

    /**
     * If there are no suggested ICD10 codes for the current
     * patient's FuR, don't filter the suggestions array
     */
    if (!suggestions.length) return suggestions;

    const existingComorbidities = this.args.changeset.get("comorbidities");
    const existingIgnoredComorbidities = this.args.changeset.get(
      "ignoredComorbidities"
    );

    /**
     * If there are existing comorbidities or ignored comorbidities
     * for the current patient, don't filter the suggestions array
     */
    if (!existingComorbidities && !existingIgnoredComorbidities.length)
      return suggestions;

    /**
     * Filter the suggestions if some have already been ignored
     * or added to the comorbidity list
     */
    return suggestions.reduce((acc: string[], curr) => {
      if (
        existingComorbidities?.includes(curr) ||
        existingIgnoredComorbidities.includes(curr)
      ) {
        return acc;
      }

      acc.push(curr);
      return acc;
    }, []);
  }

  @action
  addSuggestedComorbidity(icd10Code: string, event: PointerEvent): void {
    const comorbidities = this.args.changeset.get("comorbidities")
      ? [...this.args.changeset.get("comorbidities")]
      : [];

    comorbidities.push(icd10Code);
    this.args.changeset.set("comorbidities", comorbidities);
    event.preventDefault();
  }

  @action
  ignoreSuggestedComorbidity(icd10Code: string, event: PointerEvent): void {
    const ignoredComorbidities = this.args.changeset.get("ignoredComorbidities")
      ? [...this.args.changeset.get("ignoredComorbidities")]
      : [];

    ignoredComorbidities.push(icd10Code);
    this.args.changeset.set("ignoredComorbidities", ignoredComorbidities);
    event.preventDefault();
  }
}
